export default __webpack_public_path__ + "static/media/Ring of Mordec.b89e7501.jpg";